<ng-container>
  <c-toast-header
    [closeButton]="closeButton()"
    [cTextColor]="headerTextColor()"
    [cBgColor]="headerColor()"
  >
    @switch (severity()) {
      @case ('success') {
        <svg class="me-2" width="16" height="16" viewBox="0 0 512 512" aria-hidden="true">
          <path
            fill="currentColor"
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-33.1 361.1L120 286.2l22.6-22.6 80.3 80.3 146.9-146.9 22.6 22.6-169.5 169.5z"
          />
        </svg>
      }
      @case ('info') {
        <svg class="me-2" width="16" height="16" viewBox="0 0 512 512" aria-hidden="true">
          <path
            fill="currentColor"
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 110c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm48 286h-96v-32h32v-96h-32v-32h64v128h32v32z"
          />
        </svg>
      }
      @case ('warning') {
        <svg class="me-2" width="16" height="16" viewBox="0 0 512 512" aria-hidden="true">
          <path
            fill="currentColor"
            d="M256 32L16 464h480L256 32zm0 120c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24s-24-10.7-24-24V176c0-13.3 10.7-24 24-24zm0 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
          />
        </svg>
      }
      @case ('danger') {
        <svg class="me-2" width="16" height="16" viewBox="0 0 512 512" aria-hidden="true">
          <path
            fill="currentColor"
            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm80 328.6L328.6 344 256 271.4 183.4 344 176 336.6 248.6 264 176 191.4 183.4 184 256 256.6 328.6 184 336 191.4 263.4 264 336 336.6z"
          />
        </svg>
      }
    }
    <strong>{{ title() }}</strong>
  </c-toast-header>
  <c-toast-body
    #toastBody
    [cToastClose]="toastBody.toast ?? undefined"
    [cTextColor]="bodyTextColor()"
    [cBgColor]="color()"
  >
    {{ message() }}
  </c-toast-body>
</ng-container>
